'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var isImmutable = exports.isImmutable = function isImmutable(maybeImmutable) {
    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
};

var _isImmutableNoRecordChecks = exports._isImmutableNoRecordChecks = function _isImmutableNoRecordChecks(ii) {
    return !ii ? false : !!ii[IS_ITERABLE_SENTINEL];
};

var isCollection = exports.isCollection = function isCollection(ii) {
    return !ii ? false : !!(ii[IS_ITERABLE_SENTINEL] && !isVersion3Record(ii));
};

var isKeyed = exports.isKeyed = function isKeyed(ii) {
    return !ii ? false : !!(ii[IS_KEYED_SENTINEL] && !isVersion3Record(ii));
};

var isIndexed = exports.isIndexed = function isIndexed(ii) {
    return !ii ? false : !!ii[IS_INDEXED_SENTINEL];
};

var isAssociative = exports.isAssociative = function isAssociative(ii) {
    return isKeyed(ii) || isIndexed(ii);
};

var isOrdered = exports.isOrdered = function isOrdered(ii) {
    return !ii ? false : !!ii[IS_ORDERED_SENTINEL];
};
var isRecord = exports.isRecord = function isRecord(ii) {
    return !ii ? false : !!(ii[IS_RECORD_SENTINEL] || isVersion3Record(ii));
};

var isVersion3Record = exports.isVersion3Record = function isVersion3Record(ii) {
    return !!ii._defaultValues;
};

var isValueObject = exports.isValueObject = function isValueObject(ii) {
    return !ii ? false : typeof ii.equals === 'function' && typeof ii.hashCode === 'function';
};

var IS_ITERABLE_SENTINEL = exports.IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
var IS_KEYED_SENTINEL = exports.IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
var IS_INDEXED_SENTINEL = exports.IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
var IS_ORDERED_SENTINEL = exports.IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
var IS_RECORD_SENTINEL = exports.IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@';


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/internal/predicates.js
// module id = 193
// module chunks = 35783957827783